// Контракт ручки покрытия тем генераторами: `GET /v1/oge/coverage`.
//
// Зачем ручка, а не импорт реестра в web: словарь навыков (skills.ts) лежит в
// корневом экспорте и в бандл может, но покрытие генераторами он не знает, а
// реестр GENERATORS, который знает, лежит за барьером `@edu/shared/exercises/oge`
// вместе с правильными ответами. Бандл у web один на обе роли, поэтому реестр
// не попадает во фронт НИ ОДНИМ ПУТЁМ, и покрытие приезжает с сервера данными.
// То же решение принято для формы генераторов в docs/homework-design.md, 7.7,
// и эта ручка согласована с той по форме: `subject` обязателен с первой версии.
//
// Здесь только показываемая половина: id, название и сложность. Ответов в этих
// полях нет, поэтому файл живёт в корневом экспорте рядом с самим словарём.

import { z } from "zod";

export const OgeGeneratorInfo = z.object({
  id: z.string().min(1),
  /** Название для человека («Сложение дробей»), не текст задания. */
  title: z.string().min(1),
  /** 1 лёгкий, 2 средний, 3 сложный. Словом называет `./difficulty.ts`. */
  difficulty: z.number().int().min(1).max(3),
});
export type OgeGeneratorInfo = z.infer<typeof OgeGeneratorInfo>;

export const OgeSkillCoverage = z.object({
  /**
   * Слаг навыка. Намеренно свободная строка, а не юнион SkillSlug: старый бандл
   * обязан переварить ответ сервера, в котором появился новый навык, а не упасть
   * на разборе. Незнакомый слаг клиент молча пропускает, сверяясь со СВОИМ
   * словарём.
   */
  skill: z.string().min(1),
  generators: z.array(OgeGeneratorInfo).min(1),
});
export type OgeSkillCoverage = z.infer<typeof OgeSkillCoverage>;

export const OgeCoverageResponse = z.object({
  /**
   * Предмет, сейчас всегда `oge-math`. Обязателен с первой версии по той же
   * причине, что в справочнике 7.7 домашки: контракт без предмета вморозил бы
   * клиента в одну таксономию, а второй предмет приедет своим значением, а не
   * перетолкованием полей.
   */
  subject: z.string().min(1),
  /** Только навыки, у которых есть хотя бы один генератор: ноль это отсутствие строки. */
  skills: z.array(OgeSkillCoverage),
});
export type OgeCoverageResponse = z.infer<typeof OgeCoverageResponse>;
